<script setup>
import LocationForm from "@/components/location/LocationForm.vue";

const route = useRoute();
const router = useRouter();

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Location";

const pageMethod = "Create";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/location",
  },
  {
    title: pageMethod,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <LocationForm v-model:pageMethod="pageMethod" v-model:pageTitle="pageTitle" />
</template>
